import { render, staticRenderFns } from "./marcarConsulta.vue?vue&type=template&id=3cbca118"
import script from "./marcarConsulta.vue?vue&type=script&lang=js"
export * from "./marcarConsulta.vue?vue&type=script&lang=js"
import style0 from "./marcarConsulta.vue?vue&type=style&index=0&id=3cbca118&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports